<div>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1><i class="fas fa-building"></i> Tenant Manager</h1>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 table-area">
          <div class="card">
            <div class="overlay" *ngIf="scope.wait">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
            <div class="card-header with-border">
              <h3 class="card-title">テナント一覧</h3>
              <div class="float-right">
                <button mat-raised-button (click)="entryTenant()" color="warn">Tenant Entry</button>
              </div>
            </div>
            <div class="card-body">
              <table mat-table matSort [dataSource]="scope.dataSource" class="table table-bordered">
                <tr mat-header-row *matHeaderRowDef="scope.displayedColumns"></tr>
                <tr [ngClass]="{'remove' : row.delete_flg == 1}" mat-row *matRowDef="let row; columns: scope.displayedColumns;"></tr>             
                <ng-container matColumnDef="tenantName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Tenant Name</th>
                  <td class="tenant-cd" mat-cell *matCellDef="let element"> 
                    <a [routerLink]="['/user/index', element.tenantCd]">
                      {{element.tenantName}}
                    </a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="tel">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>TEL</th>
                  <td mat-cell *matCellDef="let element"> {{element.tel}}</td>
                </ng-container>
                <ng-container matColumnDef="mainName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Administrater</th>
                  <td mat-cell *matCellDef="let element">{{element.mainFamilyName}} {{element.mainFirstName}}</td>
                </ng-container>
                <ng-container matColumnDef="mainPosition">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Post</th>
                  <td mat-cell *matCellDef="let element"> {{element.mainPosition}}</td>
                </ng-container>
                <ng-container matColumnDef="mainEmail">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Mail</th>
                  <td mat-cell *matCellDef="let element"> {{element.mainEmail}}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell class="actions" *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element" class="text-center actions">
                    <ul class="text-center">
                      <li class="pull-left">
                        <button mat-button class="menu" [matMenuTriggerFor]="menu"><i class="fas fa-ellipsis-v"></i></button>
                        <mat-menu #menu="matMenu">
                          <!-- <button mat-menu-item [routerLink]="['/tenant/menu', element.tenantCd]">権限管理</button> -->
                          <button mat-menu-item [routerLink]="['/user/index', element.tenantCd]">ユーザ追加</button>
                          <button mat-menu-item [routerLink]="['/tenant/camera', element.tenantCd]">カメラ設定</button>
                          <button mat-menu-item (click)="delete(element)">削除</button>
                        </mat-menu>
                      </li>
                      <!-- <li class="pull-left">
                        <button mat-stroked-button color="">
                          <i class="fas fa-robot"></i>
                        </button>
                      </li> -->
                    </ul>
                  </td>
                </ng-container>
              </table>
            </div>
            <div class="box-footer">
              <mat-paginator [length]="100"
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>